<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <router-view />
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter&display=swap");

body {
  font-family: "Inter", Helvetica, Arial, sans-serif;
}
</style>
